<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <h3 class="heading-underline">Parse Resume</h3>
      <form [formGroup]="actionForm">
        <label>
          File Type
          <input type="text" class="full-width" [formControl]="resumeTypeControl" placeholder="e.g. Resume" required>
        </label>
        <label>
          Field to populate with resume text
          <app-autocomplete #resumeFieldPicker
                             [selectedOptionControl]="fieldToPopulateWithResumeControl"
                             [componentId]="'parse-resume-text-field'"
                             [placeholder]="'Choose a field...'"
                             [inputRequired]="true">
          </app-autocomplete>
        </label>
        <label>
          Field to populate with resume date
          <app-autocomplete #resumeDateFieldPicker
                             [selectedOptionControl]="fieldToPopulateWithResumeDateControl"
                             [componentId]="'parse-resume-date-field'"
                             [placeholder]="'Choose a field...'"
                             [inputRequired]="true">
          </app-autocomplete>
        </label>
        <div class="message tip">
          <i class="bhi-info"></i> This rule will find the most recent matching file attachment on each {{ primaryEntity }}, parse it, and write the text and date into the selected fields.
        </div>
      </form>
    </li>
  </ul>
</section>
